import { Card, Flex } from "@chakra-ui/react";
import { boardHeaderElements } from "../../schema/header-elements";
import { AppColors } from "@/styles/colors";
import { StandardTable } from "@/components/table/StandardTable";
import { BoardData, DefaultBoardData } from "../../schema/price-board.schema";
import dayjs from "dayjs";
import { formatCurrency } from "@/utils/format-currency";

interface Props {
  sectionData?: BoardData;
}

export const BoardTableCard = ({ sectionData }: Props) => {
  return (
    <Card.Root
      maxW="full"
      marginTop="30px"
      borderRadius="8px"
      data-testid="board-table-card"
    >
      <Card.Body
        paddingX="10px"
        paddingY="12px"
        borderRadius="8px"
        border={`1px solid ${AppColors.WHITE_BORDER_1}`}
      >
        <Flex flexDir="column" gap="18px">
          <StandardTable
            headers={boardHeaderElements}
            items={
              sectionData?.pizarra?.map((el: DefaultBoardData) => ({
                ...el,
                fecha: dayjs(el?.fecha).format("DD/MM/YYYY"),
                precioSoja: `$${formatCurrency(el?.precioSoja, false)}`,
                precioMaiz: `$${formatCurrency(el?.precioMaiz, false)}`,
                precioTrigo: `$${formatCurrency(el?.precioTrigo, false)}`,
                precioGirasol: `$${formatCurrency(el?.precioGirasol, false)}`,
                precioSorgo: `$${formatCurrency(el?.precioSorgo, false)}`,
              })) ?? []
            }
            selection={[]}
            setSelection={() => null}
            noSelection
            noActions
            noBorder
          />
        </Flex>
      </Card.Body>
    </Card.Root>
  );
};
